/**
 * @file src/core/telemetry.js
 * STUB no-op ở v1 — API có sẵn để tiết gọi được ngay, nhưng chưa gửi đi đâu.
 * Trigger làm thật: khi vượt 50 bài, hoặc khi cần trả lời "bài nào chậm".
 * Xem KE-HOACH-V0 mục 12.
 */

/**
 * @typedef {Object} Telemetry
 * @property {(name: string, props?: Record<string, string|number|boolean>) => void} event
 * @property {(name: string, ms: number) => void} timing
 * @property {() => Array<{t: number, name: string, props?: any}>} buffer  Debug panel đọc
 */

/**
 * @param {{ lessonId: string, debug?: boolean }} opts
 * @returns {Telemetry}
 */
export function createTelemetry(opts) {
  /** @type {Array<{t: number, name: string, props?: any}>} */
  const buf = [];
  const MAX = 200;

  /** @param {string} name @param {any} [props] */
  const push = (name, props) => {
    buf.push({ t: Math.round(performance.now()), name, props });
    if (buf.length > MAX) buf.shift();
    if (opts.debug) console.debug(`[telemetry] ${name}`, props ?? '');
  };

  return {
    event(name, props) {
      push(name, { lessonId: opts.lessonId, ...props });
    },
    timing(name, ms) {
      push(`timing:${name}`, { lessonId: opts.lessonId, ms: Math.round(ms) });
    },
    buffer() {
      return buf;
    },
  };
}
